import './App.css';
import AdminPanel from "./components/AdminPanel"


function App() {
  return (
    <AdminPanel/>
  );
}

export default App;
